import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SchoolService } from '../../core/school.service';
import { ActivatedRoute } from '@angular/router';
import { SeafarerAdminService } from '../../core/seafarer-admin.service';
import { SchoolAppStudentStatusBaseComponent } from '../school-app-student-status-base/school-app-student-status-base.component';

@Component({
  selector: 'app-school-app-student-on-vacation',
  templateUrl: './school-app-student-on-vacation.component.html',
  styleUrls: ['./school-app-student-on-vacation.component.css']
})
export class SchoolAppStudentOnVacationComponent extends SchoolAppStudentStatusBaseComponent implements OnInit {
  status = 'onvacation';

  constructor(
    route: ActivatedRoute,
    cookieService: CookieService,
    schoolService: SchoolService,
    seafarerAdminService: SeafarerAdminService
  ) {
    super(route, cookieService, schoolService, seafarerAdminService);
  }

}
